"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareUrlForSharing = exports.emitShareSourceMetrics = void 0;
const uuid_1 = require("uuid");
const IS_COPY_URL_PARAM = "is_copy_url";
const DEVICE_TYPE_PARAM = "device_type";
const SENDER_WEB_ID_PARAM = "sender_web_id";
// Emit metrics from incoming requests.
const emitShareSourceMetrics = (params, pageName, incrementCounter) => {
    const deviceTypeParamValue = params.get(DEVICE_TYPE_PARAM);
    const isCopyUrlParamValue = params.get(IS_COPY_URL_PARAM);
    const senderWebIdParamValue = params.get(SENDER_WEB_ID_PARAM);
    if (!pageName) {
        void incrementCounter("Share.Source.MissingPageName");
        return;
    }
    if (deviceTypeParamValue) {
        void incrementCounter(`${pageName}.Share.Source.DeviceType.${deviceTypeParamValue}`);
    }
    else {
        void incrementCounter(`${pageName}.Share.Source.DeviceType.Unknown`);
    }
    if (isCopyUrlParamValue) {
        void incrementCounter(`${pageName}.Share.Source.IsCopyUrl.${isCopyUrlParamValue}`);
    }
    else {
        void incrementCounter(`${pageName}.Share.Source.IsCopyUrl.Unknown`);
    }
    if (senderWebIdParamValue) {
        void incrementCounter(`${pageName}.Share.Source.SenderWebId.Exists`);
    }
    else {
        void incrementCounter(`${pageName}.Share.Source.SenderWebId.Unknown`);
    }
};
exports.emitShareSourceMetrics = emitShareSourceMetrics;
const webId = () => {
    const uuid = (0, uuid_1.v4)();
    return `${SENDER_WEB_ID_PARAM}=${uuid}`;
};
const deviceType = (source) => `${DEVICE_TYPE_PARAM}=${source}`;
const isCopyUrl = (shareDestinationId) => {
    if (shareDestinationId) {
        return `${IS_COPY_URL_PARAM}=false`;
    }
    return `${IS_COPY_URL_PARAM}=true`;
};
const prepareUrlForSharing = (baseUrl, source, shareDestination) => {
    const id = webId();
    const device = deviceType(source);
    const copy = isCopyUrl(shareDestination);
    const params = `${id}&${device}&${copy}`;
    if (baseUrl.includes("?"))
        return `${baseUrl}&${params}`;
    return `${baseUrl}?${params}`;
};
exports.prepareUrlForSharing = prepareUrlForSharing;
//# sourceMappingURL=sharingUtils.js.map